<template>
      <Forms ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
          >
          <div>
            <div id="form-seacch">
              <label class="labelseach">Corretor</label>
              <autocomplete-z ref="CorretorSalesReportsTypeahead"
                          placeholder="Digite um corretor"
                          iconClass="fas fa-user"
                          :serializer="(corretor) => corretor.nome"
                          :debounceLength="2"
                          :formField="formsearch.corretor"
                          v-on:search="onSearchCorretorSalesReports"
                          v-on:changeCode="onChangeCodeCorretorSalesReports"
                          :ShowCode="false"
                           />
              <label class="labelseach mt-3">Empreendimento</label>
              <select v-model="formsearch.empreendimentoId" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                <option :value="''">Todos</option>
                <option v-for="data in enteprise" v-bind:key="data.id" :value="data.id">{{data.nome}}</option>
              </select>

              <label class="labelseach mt-3">Período</label>
              <div class="periodos">
                <button id="semanal" v-on:click="filter" class="btn-periodos">SEMANAL</button>
                <button id="mensal" v-on:click="filter" class="btn-periodos">MENSAL</button>
              </div>
              <div class="periodos footer">
                <button id="anual" v-on:click="filter" class="btn-periodos btn-periodos-active">ANUAL</button>
                <button id="personalizado" v-on:click="filter"  class="btn-periodos">PERSONALIZADO</button>

              <div v-if="CustomData" class="d-flex w-100 flex-column justify-content-center">
                <label class="labelseach d-flex flex-column justify-content-center"> Desde </label>
                <b-form-datepicker
                 v-model ="formsearch.DtInicial"
                  placeholder="__/__/____"

                  locale="pt-BR"

                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"

                  ></b-form-datepicker>
                  <br>
                  <label class="labelseach d-flex w-100 flex-column justify-content-center"> Até </label>

                  <b-form-datepicker

                  v-model ="formsearch.DtFinal"

                  placeholder="__/__/____"

                  locale="pt-BR"

                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"

                  ></b-form-datepicker>

              </div>
                </div>

            </div>
          </div>
    </Forms>
</template>

<script>
import SearchSalesReportBroker from './searchsalesreportbroker'
export default SearchSalesReportBroker
</script>

<style scoped>
#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}
.labelseach{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}

.footer{
  margin-bottom: 10%;
}

.btn-footer, .footer {
  background-color: transparent !important;
}
.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;

}
.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 150px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}
.btn-periodos-active{
  background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 150px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesreportsbroker/components/searchsalesreportbroker/searchsalesreportbroker.vue